// extracted by mini-css-extract-plugin
export default {"ribbon":"TimeAwardRibbon_ribbon__r89FG"};